import { marginLeft } from '@pocketlaw/tetris';
import { Text } from '@pocketlaw/tetris/deprecated';
import styled from 'styled-components';
export const Label = styled(Text).attrs(() => ({ appearance: 'neutral', size: 'small' })) `
  ${marginLeft(1)};
`;
export const NoWrap = styled.div `
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
